export const employeesQueryKeys = {
  all: ["employees"],
  byId: (id: number | undefined) => [...employeesQueryKeys.all, id],
};
